export const AD_HOC_QUERY = 'AD_HOC_QUERY';
export const SAVED_QUERY = 'SAVED_QUERY';
export const ALERT = 'ALERT';
export const DASHBOARD = 'DASHBOARD';
export const REPORT = 'REPORT';
export const FEED = 'FEED';
